// extracted by mini-css-extract-plugin
export default {"hsStarWithLabels":"StepWizardStar_hsStarWithLabels__k7ECD","title":"StepWizardStar_title__MPb7K"};